const messages = {
  fleetWithOptions:
    "Je kunt de vloot niet kiezen als je opties hebt geselecteerd.",
  addProduct: "Uw product is toegevoegd aan de winkelwagen.",
  addProducts: "Uw producten zijn toegevoegd aan de winkelwagen.",
  profileSaved: "Uw profielgegevens zijn opgeslagen",
  canAddProduct: "Je hebt niet genoeg punten.",
  customerNumberSaved: "Klantnummer opgeslagen",
  customerNumberExist: "Klantnummer beschikbaar",
  complaintForm:
    "Uw aanvraag is geaccepteerd. Wacht alstublieft op een antwoord",
  changeParentId:
    "U kunt de bovenliggende klantnummertak niet wijzigen als deze onderliggende klanten heeft",
  requestSent: "Zoek wordt verzonden",
  completeProfileRequired:
    "U moet uw profiel 100% voltooien om door te gaan met aankopen in de winkel.",
  accessDenied: "Toegang geweigerd",
  incomplete_address: "Adres is onvolledig. Gelieve dit na te kijken",
  waitMoment: "Wacht even",
  downloadFinished: "Downloaden voltooid",
  selectOneField: "Selecteer één veld",
  noVoucher: "Voucher is niet gevonden",
  cannotAddCsNumber: "Je kunt geen klantnummer toevoegen.",
  messagesDeletedSuccess: "Berichten zijn verwijderd.",
  messagesDeletedError: "Berichten konden niet worden verwijderd.",
  fillProfile: "Fill out the profile to be able to download the certificate,",
  favoriteAdded: "Toegevoegd aan favorieten.",
  favoriteRemoved: "Verwijderd uit favorieten.",
};

export default {
  messages,
};
